import { lightTheme } from 'amazon-chime-sdk-component-library-react';

export const videoChatTheme = {
  ...lightTheme,
  fonts: {
    ...lightTheme.fonts,
    body: 'Inter, system-ui, -apple-system, sans-serif',
  },
  colors: {
    ...lightTheme.colors,
    primary: {
      lightest: '#FEF3E2',
      lighter: '#FCDFA3',
      light: '#F5C264',
      main: '#E09526',
      dark: '#C07A15',
      darker: '#9A610D',
      darkest: '#6B4009',
    },
    greys: {
      black: '#000000',
      grey100: '#1A1A1A',
      grey90: '#374151',
      grey80: '#4B5563',
      grey70: '#6B7280',
      grey60: '#9CA3AF',
      grey50: '#D1D5DB',
      grey40: '#E4E7EB',
      grey30: '#F0F2F4',
      grey20: '#F5F7F9',
      grey10: '#FAFAFA',
      white: '#FFFFFF',
    },
  },
  globalStyle: {
    bgd: '#F5F7F9',
    text: '#1A1A1A',
    fontSize: '16px',
  },
  buttons: {
    ...lightTheme.buttons,
    primary: {
      shadow: 'none',
      static: { bgd: '#E09526', border: 'none', text: '#fff', shadow: 'none' },
      hover: { bgd: '#C07A15', border: 'none', text: '#fff', shadow: 'none' },
      focus: { bgd: '#C07A15', border: '#E09526', text: '#fff', shadow: '0 0 0 2px rgba(224,149,38,0.35)' },
      active: { bgd: '#9A610D', border: 'none', text: '#fff', shadow: 'none' },
      selected: { bgd: '#9A610D', border: 'none', text: '#fff', shadow: 'none' },
      disabled: { bgd: '#E4E7EB', border: 'none', text: '#9CA3AF', shadow: 'none' },
    },
    secondary: {
      shadow: 'none',
      static: { bgd: '#FFFFFF', border: '#D1D5DB', text: '#1A1A1A', shadow: 'none' },
      hover: { bgd: '#F0F2F4', border: '#9CA3AF', text: '#1A1A1A', shadow: 'none' },
      focus: { bgd: '#F0F2F4', border: '#2EAAC7', text: '#1A1A1A', shadow: '0 0 0 2px rgba(46,170,199,0.3)' },
      active: { bgd: '#E4E7EB', border: '#9CA3AF', text: '#1A1A1A', shadow: 'none' },
      selected: { bgd: '#EBF7FB', border: '#2EAAC7', text: '#1E8FA8', shadow: 'none' },
      disabled: { bgd: '#F5F7F9', border: '#E4E7EB', text: '#9CA3AF', shadow: 'none' },
    },
    icon: {
      shadow: 'none',
      static: { bgd: 'transparent', border: 'none', text: '#6B7280', shadow: 'none' },
      hover: { bgd: '#F0F2F4', border: 'none', text: '#1A1A1A', shadow: 'none' },
      focus: { bgd: '#F0F2F4', border: '#2EAAC7', text: '#1A1A1A', shadow: '0 0 0 2px rgba(46,170,199,0.3)' },
      active: { bgd: '#EBF7FB', border: 'none', text: '#1E8FA8', shadow: 'none' },
      selected: { bgd: '#EBF7FB', border: 'none', text: '#1E8FA8', shadow: 'none' },
      disabled: { bgd: 'transparent', border: 'none', text: '#D1D5DB', shadow: 'none' },
    },
  },
  inputs: {
    ...lightTheme.inputs,
    bgd: '#F8F9FA',
    border: '#E4E7EB',
    borderRadius: '8px',
    fontColor: '#1A1A1A',
    placeholder: '#9CA3AF',
    shadow: 'none',
    clearBg: '#F0F2F4',
    focus: { bgd: '#FFFFFF', border: '#2EAAC7', shadow: '0 0 0 2px rgba(46,170,199,0.25)' },
    error: { border: '#ef4444', fontColor: '#ef4444', shadow: 'none' },
    checked: { bgd: '#2EAAC7', border: '#2EAAC7', fontColor: '#fff', shadow: 'none' },
  },
  videoGrid: {
    bgd: '#111111',
  },
  shadows: {
    none: 'none',
    small: '0 1px 3px rgba(0,0,0,0.08)',
    medium: '0 4px 6px rgba(0,0,0,0.06)',
    large: '0 10px 30px rgba(0,0,0,0.1)',
  },
};

export default videoChatTheme;